<ds-toast msThemedToast [themedToastVariant]="toastVarient" [type]="toast.type">
    <span class="toast-messages" [innerHTML]="toast.message"></span>
    <button
        class="toast-close-btn"
        slot="close"
        ds-button-icon
        variant="flat"
        kind="tertiary"
        size="small"
        [inverse]="strongInverse"
        (click)="toast.dismiss()">
        <vn-icon name="theme-ex" size="12" />
    </button>
</ds-toast>
